import type { DashboardOverview } from '@/lib/types';
import StatCard from './StatCard';
import SimpleBarChart from './SimpleBarChart';
import RecentActivity from './RecentActivity';
import QuickActions from './QuickActions';

interface TutorDashboardProps {
  data: DashboardOverview;
}

export default function TutorDashboard({ data }: TutorDashboardProps) {
  const { stats, chart, recent_activity } = data;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <StatCard label="My courses" value={stats.courses ?? 0} accent="blue" />
        <StatCard label="Enrollments" value={stats.enrollments ?? 0} accent="teal" />
        <StatCard
          label="Avg. student progress"
          value={`${stats.avg_progress ?? 0}%`}
          accent="amber"
        />
        <StatCard label="Exams" value={stats.exams ?? 0} accent="violet" />
      </div>

      <QuickActions
        actions={[
          { label: 'Create Course', to: '/courses/create' },
          { label: 'Create Exam', to: '/exams/create', variant: 'secondary' },
          { label: 'My Courses', to: '/courses', variant: 'secondary' },
        ]}
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <SimpleBarChart
          title={chart.title}
          items={chart.items}
          showSecondaryAsPercent
          emptyMessage="Create a course to see enrollment reports."
        />
        <RecentActivity
          items={recent_activity}
          emptyMessage="New student enrollments will show up here."
        />
      </div>
    </div>
  );
}
